import Konva from 'konva';

/**
 * Bola de soldadura plateada.
 *
 * Se dibuja centrada en (0,0) con radio `radiusMm`; el llamador se
 * encarga de posicionar el grupo en world-coords. Estilo: círculo con
 * gradiente radial plateado (plata brillante desplazada al noroeste
 * para simular la luz + halo oscuro en el borde para dar volumen).
 *
 * El grupo lleva `nodeKind='solder'` y `solderUid` en el shape para
 * hit-testing y selección posterior.
 */
export function renderSolderBall(solderUid: string, radiusMm: number): Konva.Group {
  const g = new Konva.Group();
  g.setAttr('nodeKind', 'solder');
  g.setAttr('solderUid', solderUid);

  const offset = -radiusMm * 0.35;
  const ball = new Konva.Circle({
    x: 0,
    y: 0,
    radius: radiusMm,
    fillRadialGradientStartPoint: { x: offset, y: offset },
    fillRadialGradientStartRadius: 0,
    fillRadialGradientEndPoint: { x: 0, y: 0 },
    fillRadialGradientEndRadius: radiusMm,
    fillRadialGradientColorStops: [
      0,   '#ffffff',
      0.15,'#e6e6ea',
      0.55,'#a9adb3',
      0.85,'#6c7075',
      1,   '#3a3d40',
    ],
    stroke: '#2b2d2f',
    strokeWidth: Math.max(0.04, radiusMm * 0.06),
    listening: true,
  });
  ball.setAttr('nodeKind', 'solder');
  ball.setAttr('solderUid', solderUid);
  g.add(ball);
  return g;
}
